import React, { useEffect, useState } from 'react';
import { MultiCombobox } from '../combobox';
import { ChallengePageEntrySupportDto } from '@api/ChallengeClient';
import { injectTSDI } from '@core/tsdi';
import { Api } from '@core/api';

export interface ChallengeMultiSelectProps {
    value: ChallengePageEntrySupportDto[];
    onChange: (value: ChallengePageEntrySupportDto[]) => void;
}

export const ChallengeMultiSelect: React.FC<ChallengeMultiSelectProps> = ({
    value,
    onChange
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [options, setOptions] = useState<ChallengePageEntrySupportDto[]>([]);
    const [loading, setLoading] = useState(false);
    const { challengeClient } = injectTSDI(Api);

    useEffect(() => {
        const fetchChallenges = async () => {
            setLoading(true);
            try {
                // Replace with actual API call to fetch challenges
                const response =
                    await challengeClient.support.challengeSupportControllerGetPage(
                        { search: searchTerm }
                    );
                setOptions(response.data.content);
            } catch (error) {
                console.error('Error fetching challenges:', error);
            } finally {
                setLoading(false);
            }
        };

        const timerId = setTimeout(() => {
            if (searchTerm) {
                fetchChallenges();
            }
        }, 500);

        return () => clearTimeout(timerId);
    }, [searchTerm]);

    return (
        <MultiCombobox
            label="Select Challenges"
            placeholder="Search challenges..."
            searchPlaceholder="Search challenges..."
            options={options}
            getOptionLabel={(option) => option.presentation.name.en || 'null'}
            getOptionKey={(option) => option.id}
            value={value}
            onChange={onChange}
            onInputChange={setSearchTerm}
            loading={loading}
            renderOption={(option) => (
                <div>
                    <p className="text-sm font-semibold">
                        {option.presentation.name.en}
                    </p>
                    <p className="text-xs text-muted-foreground">
                        Community {option.community.name}
                    </p>
                    {option.community.tenantId !== undefined && (
                        <p className="text-xs text-muted-foreground">
                            Tenant: {option.community.tenantId}
                        </p>
                    )}
                </div>
            )}
        />
    );
};
